class Logger {
  constructor() {
    this.isDebugMode = process.env.NODE_ENV === 'development' || 
                      localStorage.getItem('DEBUG_LOGGING') === 'true';
    this.isWebSocketDebug = localStorage.getItem('WEBSOCKET_DEBUG') === 'true';
    this.isConciergeDebug = localStorage.getItem('CONCIERGE_DEBUG') === 'true';
    this.isChatDebug = localStorage.getItem('CHAT_DEBUG') === 'true';
    this.isNotificationDebug = localStorage.getItem('NOTIFICATION_DEBUG') === 'true';
    this.isApiDebug = localStorage.getItem('API_DEBUG') === 'true';
  }

  // General logging
  log(message, data = null) {
    if (this.isDebugMode) {
      if (data) {
        console.log(`[LOG] ${message}`, data);
      } else {
        console.log(`[LOG] ${message}`);
      }
    }
  }

  // WebSocket logging
  websocket(message, data = null) {
    if (this.isWebSocketDebug || this.isDebugMode) {
      if (data) {
        console.log(`🌐 [WebSocket] ${message}`, data);
      } else {
        console.log(`🌐 [WebSocket] ${message}`);
      }
    }
  }

  // Concierge service logging
  concierge(message, data = null) {
    if (this.isConciergeDebug || this.isDebugMode) {
      if (data) {
        console.log(`🤖 [Concierge] ${message}`, data);
      } else {
        console.log(`🤖 [Concierge] ${message}`);
      }
    }
  }

  // Chat system logging
  chat(message, data = null) {
    if (this.isChatDebug || this.isDebugMode) {
      if (data) {
        console.log(`💬 [Chat] ${message}`, data);
      } else {
        console.log(`💬 [Chat] ${message}`);
      }
    }
  }

  // Notification logging
  notification(message, data = null) {
    if (this.isNotificationDebug || this.isDebugMode) {
      if (data) {
        console.log(`🔔 [Notification] ${message}`, data);
      } else {
        console.log(`🔔 [Notification] ${message}`);
      }
    }
  }

  // API logging
  api(message, data = null) {
    if (this.isApiDebug || this.isDebugMode) {
      if (data) {
        console.log(`🔗 [API] ${message}`, data);
      } else {
        console.log(`🔗 [API] ${message}`);
      }
    }
  }

  // Error logging (always shown)
  error(message, error = null) {
    if (error) {
      console.error(`❌ [Error] ${message}`, error);
    } else {
      console.error(`❌ [Error] ${message}`);
    }
  }

  // Warning logging
  warn(message, data = null) {
    if (this.isDebugMode) {
      if (data) {
        console.warn(`⚠️ [Warning] ${message}`, data);
      } else {
        console.warn(`⚠️ [Warning] ${message}`);
      }
    }
  }

  // Success logging
  success(message, data = null) {
    if (this.isDebugMode) {
      if (data) {
        console.log(`✅ [Success] ${message}`, data);
      } else {
        console.log(`✅ [Success] ${message}`);
      }
    }
  }

  // Debug logging (only in debug mode)
  debug(message, data = null) {
    if (this.isDebugMode) {
      if (data) {
        console.log(`🐛 [Debug] ${message}`, data);
      } else {
        console.log(`🐛 [Debug] ${message}`);
      }
    }
  }

  // Group logging for complex operations
  group(name, fn) {
    if (this.isDebugMode) {
      console.group(name);
      fn();
      console.groupEnd();
    }
  }

  // Time logging for performance
  time(label) {
    if (this.isDebugMode) {
      console.time(label);
    }
  }

  timeEnd(label) {
    if (this.isDebugMode) {
      console.timeEnd(label);
    }
  }
}

// Create singleton instance
const logger = new Logger();

export default logger;
